import { Modal } from 'flowbite-react';
import { FormikProvider, useFormik } from 'formik';

import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';

import { useEffect, useState } from 'react';
import { updateLeadProps } from '../../../../common/services/leads.api';
import { LEAD_STATUS } from '../../../../types/lead.type';

type Props = {
  lead: string;
  onClose: () => void
}

export default function ModalRestoreLead(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()
  const [ isRestored, setIsRestored ] = useState(false);
  const [submitResult, setSubmitResult] = useState<string | null>(null);

  const formik = useFormik({
    initialValues: {
      leadId: props.lead
    },
    onSubmit: async (data) => {
      const leadData = {
        status: LEAD_STATUS.NewLead
      }
      const result = await updateLeadProps(data.leadId, leadData)
      if (!result.ok) {
        notifyError(result.message as string)
        setSubmitResult('error');
        return
      }
      notifySuccess("Lead restaurado com sucesso!")
      setSubmitResult('success');
    }
  })

  useEffect(() => {
    setIsRestored(submitResult === 'success')
  }, [submitResult]);

  return (
    <Modal
      className='relative dark:text-black '
      show={true}
      onClose={() => props.onClose()}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header className='dark:text-black'>
            <h2 className='dark:text-black'>Restaurar Lead</h2>
          </Modal.Header>

          <Modal.Body className='w-full relative items-center justify-center border-gray flex flex-col'>
            <div className='pb-[20px]'>
              <h2 className="font-semibold ">Tem certeza que deseja restaurar este lead?</h2>
            </div>
            <div>
              <ButtonWithLoader
                isLoading={formik.isSubmitting}
                disabled={isRestored}
                onSave={() => setIsRestored(true)}>
                Sim
              </ButtonWithLoader>
            </div>
          </Modal.Body>
        </FormikProvider>
      </form>

      <Modal.Footer>
      </Modal.Footer>

    </Modal >
  );
}
